const downloadFiles = (urls: string | string[]): void => {
  const urlList = Array.isArray(urls) ? urls : [urls]

  urlList
    .filter(url => !!url)
    .forEach(url => {
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = ''
      anchor.style.display = 'none'

      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
    })
}

export default downloadFiles
